export const GET_ALL_SECTIONS = '/sections/page/:label';
export const GET_SECTION_CONTENT =
	'/sections/:id/content?offset=0&limit=:main_limit';
